
import Customers from '../views/customer/Customers.vue'
import CustomerDetail from '../views/customer/CustomerDetail.vue'

const customers = [
    { path: '/customers', name: 'customers', component: Customers },
    { path: '/customer/:target', name: 'customer_detail', component: CustomerDetail },
]

export default {
    customers
}

// function lazyLoad(view) {
//     return () => import(`@/views/customer/${view}.vue`)
// }

// const customers = [
//     { path: '/customers', name: 'customers', component: lazyLoad('Customers') },
//     { path: '/customer/:target', name: 'customer_detail', component: lazyLoad('CustomerDetail') },
// ]
